module.exports = {"classes":["preference-center-page"],"title":"Preference Center","metas":{"description":""},"opengraph":{"og:title":"","og:description":"","og:url":"https://auth0.com/preference-center","og:image":"","og:image:secure_url":""},"twittercard":{"twitter:title":"","twitter:description":"","twitter:image":[{"src":""}]}}


//////////////////
// WEBPACK FOOTER
// ./src/pages/preference-center/data/metadata.json
// module id = 1655
// module chunks = 0